export default __webpack_public_path__ + "static/media/arrow_on.ae9d839a.png";